import { useEffect } from 'react'

import PropTypes from 'prop-types'

import { FetchHelper } from '../../helpers/fetch'

import { useAppContext } from '../useAppContext'
import { useSimpleState } from '../useSimpleState'

const DEFAULT_PER_PAGE = 10

const useControlSearch = (props={}) => {
    const {ac} = useAppContext()

    const {_state} = useSimpleState({})

    const {_state: _params} = useSimpleState(props.params || {})

    const {_state: _results} = useSimpleState()

    const {_state: _pagination} = useSimpleState({
        page: 1,
        lastPage: 1,
        totalDates: 0,
        perPage: props.perPage || DEFAULT_PER_PAGE,
        loadingMore: false
    })

    const getParams = (page, extra={}) => {
        let params = new URLSearchParams()
        let priceFinalParams = _params.get('priceFinal')
        let q = _params.get('q')

        if (priceFinalParams) {
            params.append('priceFinal[gte]', priceFinalParams[0])
            params.append('priceFinal[lte]', priceFinalParams[1])
        }

        if (q) {
            params.append('q', q)
        }

        params.append('page', page)
        params.append('datesPerPage', _pagination.get('perPage'))

        if (extra.date) {
            params.append('date', extra.date)
        }

        return `?${params.toString()}`
    }

    const applyResponse = (res, { append }) => {
        if (append) {
            let existing = _results.get()?.body?.data || []
            _results.set({ ...res, body: { ...res.body, data: [...existing, ...res.body.data] } })
        } else {
            _results.set(res)
        }

        _pagination.set('page', res.body.meta.currentPage)
        _pagination.set('lastPage', res.body.meta.lastPage)
        _pagination.set('totalDates', res.body.meta.totalDates)
    }

    const fetch = (page = 1) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: `/api/v1/deals${getParams(page)}`
        })
            .then((res) => {
                if (res.status === 200) {
                    applyResponse(res, { append: false })
                }
            })
            .catch((res) => {
                console.log('control search fetch error', res)
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const loadMore = () => {
        let { page, lastPage, loadingMore } = _pagination.get()

        if (loadingMore || page >= lastPage)
            return Promise.resolve()

        _pagination.set('loadingMore', true)

        return FetchHelper({
            url: `/api/v1/deals${getParams(page + 1)}`
        })
            .then((res) => {
                if (res.status === 200) {
                    applyResponse(res, { append: true })
                }
            })
            .catch((res) => {
                console.log('control search load more error', res)
            })
            .finally(() => {
                _pagination.set('loadingMore', false)
            })
    }

    const goToPage = (page) => {
        return fetch(page)
    }

    const goToDate = (date) => {
        if (props.beforeFetch)
            props.beforeFetch()

        return FetchHelper({
            url: `/api/v1/deals${getParams(1, { date })}`
        })
            .then((res) => {
                if (res.status === 200) {
                    applyResponse(res, { append: false })
                }
            })
            .catch((res) => {
                console.log('control search go to date error', res)
            })
            .finally(() => {
                if (props.afterFetch)
                    props.afterFetch()
            })
    }

    const hasMore = () => {
        let { page, lastPage } = _pagination.get()
        return page < lastPage
    }

    const fetchClick = (item) => {
        return FetchHelper({
            url: '/api/v1/deals/click',
            options: {
                method: 'put',
                data: {
                    id: item.id
                }
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
    }

    const fetchClickDead = (item) => {
        return FetchHelper({
            url: '/api/v1/deals/click_dead',
            options: {
                method: 'put',
                data: {
                    id: item.id
                }
            }
        })
            .then((res) => {
                return res
            })
            .catch((res) => {
                return res
            })
    }

    useEffect(() => {
        fetch(1)
    }, [_params.get()])

    const set = (key, params) => {
        _params.set({
            ..._params.get(),
            key: params
        })
    }

    return Object.freeze({
        _results,
        _params,
        _pagination,
        _control: {
            fetch,
            loadMore,
            goToPage,
            goToDate,
            hasMore,
            fetchClick,
            fetchClickDead,
            set
        }
    })
}

useControlSearch.propTypes = {
    beforeFetch: PropTypes.func,
    afterFetch: PropTypes.func,
    params: PropTypes.object,
    perPage: PropTypes.number,
}

export { useControlSearch }
